<template>
  <div class="store__products">
    <router-link :to="{ name: 'order-summary' }" class="btn-next">Next <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512"><path fill="#464646" d="M166.9 264.5l-117.8 116c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L127.3 256 25.1 155.6c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l117.8 116c4.6 4.7 4.6 12.3-.1 17z"/></svg></router-link>

    <h1 class="store-headline">{{ headline }}</h1>
    
    <div v-html="content"></div>

    <div class="store__products-layout">
      <div class="store__products-sidebar">
        <product-filters></product-filters>
      </div>
      
      <div class="store__products-primary">
        <div class="products">
            
          <div class="product" v-for="(product, index) in products">
            <div>
              <div class="product__img">
                <img v-bind:src="product.image" alt="">
              </div>
              
              <div class="product__info">
                <span class="product__brand">{{ (product.brands && product.brands[0]) ? product.brands[0].name : '' }}</span>
                <!--<span class="product__size">0.5 Liter Bottled Water</span>-->
                <span class="product__name" v-html="product.name"></span>
                <span class="product__qty">{{ product.size }}</span>
              </div>
            </div>
            
            <div>
              <span class="product__price">${{ product.price }} {{ product.price_unit || 'ea' }}</span>
              <router-link 
                :to="{ name: 'product-detail', params: { productId: product.id }}" 
                class="btn btn-store" 
              >View Product</router-link>
            </div>
          </div> <!-- .product -->
          
          <div class="product product--placeholder"></div>
        </div> <!-- .products -->
        
        <p class="mrgn-top-20" v-if="products.length == 0">There are no results that match your search.</p>
      </div> <!-- .store__products-primary -->
    </div> <!-- .store__products-layout -->

    <hr class="hr--bottom">

    <router-link :to="{ name: 'order-summary' }" class="btn-next">Next <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 512"><path fill="#464646" d="M166.9 264.5l-117.8 116c-4.7 4.7-12.3 4.7-17 0l-7.1-7.1c-4.7-4.7-4.7-12.3 0-17L127.3 256 25.1 155.6c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0l117.8 116c4.6 4.7 4.6 12.3-.1 17z"/></svg></router-link>
  </div> <!-- .store__products -->
</template>

<script>
import store from '../store.js'
import ProductFilters from './ProductFilters.vue'

export default {
  data() {
    return {
      headline: 'Need Water For On the Go or Salt? Add Below!',
      content: '',
    }
  },
  computed: {
    products() {
      return store.getters.getFilteredProducts
    }
  },
  created() {
    // Page content
    // this.headline = window.pages.products.page.headline || ''
    // this.content = window.pages.products.page.content || ''
  },
  mounted() {
    store.dispatch('setCurrentStep', 'products')
  },
  components: {
    ProductFilters,
  }
}
</script>
